export class IntegracaoVariavelModel {
  ordem?: number;
  campo?: string;
}

export class IntegracaoModel {
  id?: number;
  nome?: string;
  personalizada?: boolean;
  url?: string;
  token?: string;
  payload?: string;
  payloadUrl?: string;
  variaveis: IntegracaoVariavelModel[] = [];
}

export class IntegracaoPaginaModel {
  content: IntegracaoModel[] = [];
  totalPages = 0;
  totalElements = 0;
  size = 20;
  number = 0;
  numberOfElements = 0;
}
